import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';

type LastToastMessage = {
  message: string;
  time: number;
};

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private lastMessage: LastToastMessage | null = null;

  constructor(private readonly toastrService: ToastrService) {}

  private readonly toasts: any;

  showSuccess(msg?, title?) {
    this.toastrService.success(msg, title);
  }

  showSuccessWithTimeout(msg?): Promise<any> {
    return new Promise<any>((resolve) => {
      this.toastrService.success(msg);
      setTimeout(() => resolve(true), 1000);
    });
  }

  showError(error?, title?): ActiveToast<any> {
    if (!!this.lastMessage && this.lastMessage.message === error && Date.now() - this.lastMessage.time < 1500) {
      this.lastMessage.time = Date.now();
      return;
    } else {
      this.lastMessage = {
        message: error,
        time: Date.now(),
      };
    }

    return this.toastrService.error(error, title);
  }

  showWarning(warning?, title?): ActiveToast<any> {
    return this.toastrService.warning(warning, title);
  }

  showInfo(info?, title?): ActiveToast<any> {
    return this.toastrService.info(info, title);
  }

  clear() {
    this.toastrService.clear();
  }
}
